import { jsx as a, jsxs as ae } from "react/jsx-runtime";
import * as c from "react";
import { forwardRef as S } from "react";
import { c as v } from "./index-DLeNytVF.js";
import { c as Re, u as K } from "./index-DLcqcWxM.js";
import { c as be } from "./index-UFb2E87s.js";
import { u as De } from "./index-DYfkNB0n.js";
import { P as A, c as An, d as On } from "./index-BrTLHETv.js";
import { c as kn } from "./index-CUE0gmT0.js";
import { u as Ln } from "./index-ByaXH_ih.js";
import { D as Gn } from "./index-Dz0AUfZX.js";
import { u as Fn, R as Kn, F as $n, h as Un } from "./index-BUY6qYfp.js";
import { u as H } from "./index-umR1UobZ.js";
import { c as ye, A as Bn, C as zn, R as Se, a as Vn } from "./index-Duz4GUys.js";
import { P as jn } from "./index-CsGiVPqA.js";
import { P as q } from "./index-L6dgm95g.js";
import { c as Ie, I as Xn, R as Yn } from "./index-Dk8WN7YM.js";
import { u as ce } from "./index-DwYXX2sM.js";
import { C as Hn, c as Wn, f as Zn } from "./react-icons.esm-CDi78UIJ.js";
import { $ as D } from "./utils-CTvPli9r.js";
var re = ["Enter", " "], qn = ["ArrowDown", "PageUp", "Home"], xe = ["ArrowUp", "PageDown", "End"], Jn = [...qn, ...xe], Qn = {
  ltr: [...re, "ArrowRight"],
  rtl: [...re, "ArrowLeft"]
}, eo = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, $ = "Menu", [G, no, oo] = kn($), [P, Pe] = be($, [
  oo,
  ye,
  Ie
]), U = ye(), Ne = Ie(), [Ee, I] = P($), [to, B] = P($), Te = (e) => {
  const { __scopeMenu: o, open: n = !1, children: t, dir: r, onOpenChange: s, modal: u = !0 } = e, d = U(o), [m, M] = c.useState(null), p = c.useRef(!1), i = ce(s), f = Ln(r);
  return c.useEffect(() => {
    const h = () => {
      p.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => p.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ a(Se, { ...d, children: /* @__PURE__ */ a(
    Ee,
    {
      scope: o,
      open: n,
      onOpenChange: i,
      content: m,
      onContentChange: M,
      children: /* @__PURE__ */ a(
        to,
        {
          scope: o,
          onClose: c.useCallback(() => i(!1), [i]),
          isUsingKeyboardRef: p,
          dir: f,
          modal: u,
          children: t
        }
      )
    }
  ) });
};
Te.displayName = $;
var ro = "MenuAnchor", se = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e, r = U(n);
    return /* @__PURE__ */ a(Bn, { ...r, ...t, ref: o });
  }
);
se.displayName = ro;
var ie = "MenuPortal", [ao, Ae] = P(ie, {
  forceMount: void 0
}), Oe = (e) => {
  const { __scopeMenu: o, forceMount: n, children: t, container: r } = e, s = I(ie, o);
  return /* @__PURE__ */ a(ao, { scope: o, forceMount: n, children: /* @__PURE__ */ a(q, { present: n || s.open, children: /* @__PURE__ */ a(jn, { asChild: !0, container: r, children: t }) }) });
};
Oe.displayName = ie;
var _ = "MenuContent", [co, ue] = P(_), ke = c.forwardRef(
  (e, o) => {
    const n = Ae(_, e.__scopeMenu), { forceMount: t = n.forceMount, ...r } = e, s = I(_, e.__scopeMenu), u = B(_, e.__scopeMenu);
    return /* @__PURE__ */ a(G.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ a(q, { present: t || s.open, children: /* @__PURE__ */ a(G.Slot, { scope: e.__scopeMenu, children: u.modal ? /* @__PURE__ */ a(so, { ...r, ref: o }) : /* @__PURE__ */ a(io, { ...r, ref: o }) }) }) });
  }
), so = c.forwardRef(
  (e, o) => {
    const n = I(_, e.__scopeMenu), t = c.useRef(null), r = K(o, t);
    return c.useEffect(() => {
      const s = t.current;
      if (s) return Un(s);
    }, []), /* @__PURE__ */ a(
      de,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: v(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), io = c.forwardRef((e, o) => {
  const n = I(_, e.__scopeMenu);
  return /* @__PURE__ */ a(
    de,
    {
      ...e,
      ref: o,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), uo = An("MenuContent.ScrollLock"), de = c.forwardRef(
  (e, o) => {
    const {
      __scopeMenu: n,
      loop: t = !1,
      trapFocus: r,
      onOpenAutoFocus: s,
      onCloseAutoFocus: u,
      disableOutsidePointerEvents: d,
      onEntryFocus: m,
      onEscapeKeyDown: M,
      onPointerDownOutside: p,
      onFocusOutside: i,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: g,
      ...x
    } = e, N = I(_, n), O = B(_, n), z = U(n), V = Ne(n), Me = no(n), [In, ve] = c.useState(null), j = c.useRef(null), xn = K(o, j, N.onContentChange), X = c.useRef(0), Y = c.useRef(""), Pn = c.useRef(0), ee = c.useRef(null), ge = c.useRef("right"), ne = c.useRef(0), Nn = g ? Kn : c.Fragment, En = g ? { as: uo, allowPinchZoom: !0 } : void 0, Tn = (l) => {
      var T, we;
      const C = Y.current + l, R = Me().filter((b) => !b.disabled), y = document.activeElement, oe = (T = R.find((b) => b.ref.current === y)) == null ? void 0 : T.textValue, te = R.map((b) => b.textValue), he = Ro(te, C, oe), k = (we = R.find((b) => b.textValue === he)) == null ? void 0 : we.ref.current;
      (function b(Ce) {
        Y.current = Ce, window.clearTimeout(X.current), Ce !== "" && (X.current = window.setTimeout(() => b(""), 1e3));
      })(C), k && setTimeout(() => k.focus());
    };
    c.useEffect(() => () => window.clearTimeout(X.current), []), Fn();
    const E = c.useCallback((l) => {
      var R, y;
      return ge.current === ((R = ee.current) == null ? void 0 : R.side) && Do(l, (y = ee.current) == null ? void 0 : y.area);
    }, []);
    return /* @__PURE__ */ a(
      co,
      {
        scope: n,
        searchRef: Y,
        onItemEnter: c.useCallback(
          (l) => {
            E(l) && l.preventDefault();
          },
          [E]
        ),
        onItemLeave: c.useCallback(
          (l) => {
            var C;
            E(l) || ((C = j.current) == null || C.focus(), ve(null));
          },
          [E]
        ),
        onTriggerLeave: c.useCallback(
          (l) => {
            E(l) && l.preventDefault();
          },
          [E]
        ),
        pointerGraceTimerRef: Pn,
        onPointerGraceIntentChange: c.useCallback((l) => {
          ee.current = l;
        }, []),
        children: /* @__PURE__ */ a(Nn, { ...En, children: /* @__PURE__ */ a(
          $n,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: v(s, (l) => {
              var C;
              l.preventDefault(), (C = j.current) == null || C.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: u,
            children: /* @__PURE__ */ a(
              Gn,
              {
                asChild: !0,
                disableOutsidePointerEvents: d,
                onEscapeKeyDown: M,
                onPointerDownOutside: p,
                onFocusOutside: i,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ a(
                  Yn,
                  {
                    asChild: !0,
                    ...V,
                    dir: O.dir,
                    orientation: "vertical",
                    loop: t,
                    currentTabStopId: In,
                    onCurrentTabStopIdChange: ve,
                    onEntryFocus: v(m, (l) => {
                      O.isUsingKeyboardRef.current || l.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ a(
                      zn,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Je(N.open),
                        "data-radix-menu-content": "",
                        dir: O.dir,
                        ...z,
                        ...x,
                        ref: xn,
                        style: { outline: "none", ...x.style },
                        onKeyDown: v(x.onKeyDown, (l) => {
                          const R = l.target.closest("[data-radix-menu-content]") === l.currentTarget, y = l.ctrlKey || l.altKey || l.metaKey, oe = l.key.length === 1;
                          R && (l.key === "Tab" && l.preventDefault(), !y && oe && Tn(l.key));
                          const te = j.current;
                          if (l.target !== te || !Jn.includes(l.key)) return;
                          l.preventDefault();
                          const k = Me().filter((T) => !T.disabled).map((T) => T.ref.current);
                          xe.includes(l.key) && k.reverse(), Co(k);
                        }),
                        onBlur: v(e.onBlur, (l) => {
                          l.currentTarget.contains(l.target) || (window.clearTimeout(X.current), Y.current = "");
                        }),
                        onPointerMove: v(
                          e.onPointerMove,
                          F((l) => {
                            const C = l.target, R = ne.current !== l.clientX;
                            if (l.currentTarget.contains(C) && R) {
                              const y = l.clientX > ne.current ? "right" : "left";
                              ge.current = y, ne.current = l.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ke.displayName = _;
var lo = "MenuGroup", le = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e;
    return /* @__PURE__ */ a(A.div, { role: "group", ...t, ref: o });
  }
);
le.displayName = lo;
var po = "MenuLabel", Le = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e;
    return /* @__PURE__ */ a(A.div, { ...t, ref: o });
  }
);
Le.displayName = po;
var W = "MenuItem", _e = "menu.itemSelect", J = c.forwardRef(
  (e, o) => {
    const { disabled: n = !1, onSelect: t, ...r } = e, s = c.useRef(null), u = B(W, e.__scopeMenu), d = ue(W, e.__scopeMenu), m = K(o, s), M = c.useRef(!1), p = () => {
      const i = s.current;
      if (!n && i) {
        const f = new CustomEvent(_e, { bubbles: !0, cancelable: !0 });
        i.addEventListener(_e, (h) => t == null ? void 0 : t(h), { once: !0 }), On(i, f), f.defaultPrevented ? M.current = !1 : u.onClose();
      }
    };
    return /* @__PURE__ */ a(
      Ge,
      {
        ...r,
        ref: m,
        disabled: n,
        onClick: v(e.onClick, p),
        onPointerDown: (i) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, i), M.current = !0;
        },
        onPointerUp: v(e.onPointerUp, (i) => {
          var f;
          M.current || (f = i.currentTarget) == null || f.click();
        }),
        onKeyDown: v(e.onKeyDown, (i) => {
          const f = d.searchRef.current !== "";
          n || f && i.key === " " || re.includes(i.key) && (i.currentTarget.click(), i.preventDefault());
        })
      }
    );
  }
);
J.displayName = W;
var Ge = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, disabled: t = !1, textValue: r, ...s } = e, u = ue(W, n), d = Ne(n), m = c.useRef(null), M = K(o, m), [p, i] = c.useState(!1), [f, h] = c.useState("");
    return c.useEffect(() => {
      const g = m.current;
      g && h((g.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ a(
      G.ItemSlot,
      {
        scope: n,
        disabled: t,
        textValue: r ?? f,
        children: /* @__PURE__ */ a(Xn, { asChild: !0, ...d, focusable: !t, children: /* @__PURE__ */ a(
          A.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": t || void 0,
            "data-disabled": t ? "" : void 0,
            ...s,
            ref: M,
            onPointerMove: v(
              e.onPointerMove,
              F((g) => {
                t ? u.onItemLeave(g) : (u.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: v(
              e.onPointerLeave,
              F((g) => u.onItemLeave(g))
            ),
            onFocus: v(e.onFocus, () => i(!0)),
            onBlur: v(e.onBlur, () => i(!1))
          }
        ) })
      }
    );
  }
), fo = "MenuCheckboxItem", Fe = c.forwardRef(
  (e, o) => {
    const { checked: n = !1, onCheckedChange: t, ...r } = e;
    return /* @__PURE__ */ a(ze, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ a(
      J,
      {
        role: "menuitemcheckbox",
        "aria-checked": Z(n) ? "mixed" : n,
        ...r,
        ref: o,
        "data-state": me(n),
        onSelect: v(
          r.onSelect,
          () => t == null ? void 0 : t(Z(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Fe.displayName = fo;
var Ke = "MenuRadioGroup", [mo, Mo] = P(
  Ke,
  { value: void 0, onValueChange: () => {
  } }
), $e = c.forwardRef(
  (e, o) => {
    const { value: n, onValueChange: t, ...r } = e, s = ce(t);
    return /* @__PURE__ */ a(mo, { scope: e.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ a(le, { ...r, ref: o }) });
  }
);
$e.displayName = Ke;
var Ue = "MenuRadioItem", Be = c.forwardRef(
  (e, o) => {
    const { value: n, ...t } = e, r = Mo(Ue, e.__scopeMenu), s = n === r.value;
    return /* @__PURE__ */ a(ze, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ a(
      J,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...t,
        ref: o,
        "data-state": me(s),
        onSelect: v(
          t.onSelect,
          () => {
            var u;
            return (u = r.onValueChange) == null ? void 0 : u.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Be.displayName = Ue;
var pe = "MenuItemIndicator", [ze, vo] = P(
  pe,
  { checked: !1 }
), Ve = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, forceMount: t, ...r } = e, s = vo(pe, n);
    return /* @__PURE__ */ a(
      q,
      {
        present: t || Z(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ a(
          A.span,
          {
            ...r,
            ref: o,
            "data-state": me(s.checked)
          }
        )
      }
    );
  }
);
Ve.displayName = pe;
var go = "MenuSeparator", je = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e;
    return /* @__PURE__ */ a(
      A.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...t,
        ref: o
      }
    );
  }
);
je.displayName = go;
var ho = "MenuArrow", Xe = c.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e, r = U(n);
    return /* @__PURE__ */ a(Vn, { ...r, ...t, ref: o });
  }
);
Xe.displayName = ho;
var fe = "MenuSub", [wo, Ye] = P(fe), He = (e) => {
  const { __scopeMenu: o, children: n, open: t = !1, onOpenChange: r } = e, s = I(fe, o), u = U(o), [d, m] = c.useState(null), [M, p] = c.useState(null), i = ce(r);
  return c.useEffect(() => (s.open === !1 && i(!1), () => i(!1)), [s.open, i]), /* @__PURE__ */ a(Se, { ...u, children: /* @__PURE__ */ a(
    Ee,
    {
      scope: o,
      open: t,
      onOpenChange: i,
      content: M,
      onContentChange: p,
      children: /* @__PURE__ */ a(
        wo,
        {
          scope: o,
          contentId: H(),
          triggerId: H(),
          trigger: d,
          onTriggerChange: m,
          children: n
        }
      )
    }
  ) });
};
He.displayName = fe;
var L = "MenuSubTrigger", We = c.forwardRef(
  (e, o) => {
    const n = I(L, e.__scopeMenu), t = B(L, e.__scopeMenu), r = Ye(L, e.__scopeMenu), s = ue(L, e.__scopeMenu), u = c.useRef(null), { pointerGraceTimerRef: d, onPointerGraceIntentChange: m } = s, M = { __scopeMenu: e.__scopeMenu }, p = c.useCallback(() => {
      u.current && window.clearTimeout(u.current), u.current = null;
    }, []);
    return c.useEffect(() => p, [p]), c.useEffect(() => {
      const i = d.current;
      return () => {
        window.clearTimeout(i), m(null);
      };
    }, [d, m]), /* @__PURE__ */ a(se, { asChild: !0, ...M, children: /* @__PURE__ */ a(
      Ge,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": Je(n.open),
        ...e,
        ref: Re(o, r.onTriggerChange),
        onClick: (i) => {
          var f;
          (f = e.onClick) == null || f.call(e, i), !(e.disabled || i.defaultPrevented) && (i.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: v(
          e.onPointerMove,
          F((i) => {
            s.onItemEnter(i), !i.defaultPrevented && !e.disabled && !n.open && !u.current && (s.onPointerGraceIntentChange(null), u.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: v(
          e.onPointerLeave,
          F((i) => {
            var h, g;
            p();
            const f = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (f) {
              const x = (g = n.content) == null ? void 0 : g.dataset.side, N = x === "right", O = N ? -5 : 5, z = f[N ? "left" : "right"], V = f[N ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: i.clientX + O, y: i.clientY },
                  { x: z, y: f.top },
                  { x: V, y: f.top },
                  { x: V, y: f.bottom },
                  { x: z, y: f.bottom }
                ],
                side: x
              }), window.clearTimeout(d.current), d.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(i), i.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: v(e.onKeyDown, (i) => {
          var h;
          const f = s.searchRef.current !== "";
          e.disabled || f && i.key === " " || Qn[t.dir].includes(i.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), i.preventDefault());
        })
      }
    ) });
  }
);
We.displayName = L;
var Ze = "MenuSubContent", qe = c.forwardRef(
  (e, o) => {
    const n = Ae(_, e.__scopeMenu), { forceMount: t = n.forceMount, ...r } = e, s = I(_, e.__scopeMenu), u = B(_, e.__scopeMenu), d = Ye(Ze, e.__scopeMenu), m = c.useRef(null), M = K(o, m);
    return /* @__PURE__ */ a(G.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ a(q, { present: t || s.open, children: /* @__PURE__ */ a(G.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ a(
      de,
      {
        id: d.contentId,
        "aria-labelledby": d.triggerId,
        ...r,
        ref: M,
        align: "start",
        side: u.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          var i;
          u.isUsingKeyboardRef.current && ((i = m.current) == null || i.focus()), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: v(e.onFocusOutside, (p) => {
          p.target !== d.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: v(e.onEscapeKeyDown, (p) => {
          u.onClose(), p.preventDefault();
        }),
        onKeyDown: v(e.onKeyDown, (p) => {
          var h;
          const i = p.currentTarget.contains(p.target), f = eo[u.dir].includes(p.key);
          i && f && (s.onOpenChange(!1), (h = d.trigger) == null || h.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
qe.displayName = Ze;
function Je(e) {
  return e ? "open" : "closed";
}
function Z(e) {
  return e === "indeterminate";
}
function me(e) {
  return Z(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Co(e) {
  const o = document.activeElement;
  for (const n of e)
    if (n === o || (n.focus(), document.activeElement !== o)) return;
}
function _o(e, o) {
  return e.map((n, t) => e[(o + t) % e.length]);
}
function Ro(e, o, n) {
  const r = o.length > 1 && Array.from(o).every((M) => M === o[0]) ? o[0] : o, s = n ? e.indexOf(n) : -1;
  let u = _o(e, Math.max(s, 0));
  r.length === 1 && (u = u.filter((M) => M !== n));
  const m = u.find(
    (M) => M.toLowerCase().startsWith(r.toLowerCase())
  );
  return m !== n ? m : void 0;
}
function bo(e, o) {
  const { x: n, y: t } = e;
  let r = !1;
  for (let s = 0, u = o.length - 1; s < o.length; u = s++) {
    const d = o[s], m = o[u], M = d.x, p = d.y, i = m.x, f = m.y;
    p > t != f > t && n < (i - M) * (t - p) / (f - p) + M && (r = !r);
  }
  return r;
}
function Do(e, o) {
  if (!o) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return bo(n, o);
}
function F(e) {
  return (o) => o.pointerType === "mouse" ? e(o) : void 0;
}
var yo = Te, So = se, Io = Oe, xo = ke, Po = le, No = Le, Eo = J, To = Fe, Ao = $e, Oo = Be, ko = Ve, Lo = je, Go = Xe, Fo = He, Ko = We, $o = qe, Q = "DropdownMenu", [Uo, Lt] = be(
  Q,
  [Pe]
), w = Pe(), [Bo, Qe] = Uo(Q), en = (e) => {
  const {
    __scopeDropdownMenu: o,
    children: n,
    dir: t,
    open: r,
    defaultOpen: s,
    onOpenChange: u,
    modal: d = !0
  } = e, m = w(o), M = c.useRef(null), [p, i] = De({
    prop: r,
    defaultProp: s ?? !1,
    onChange: u,
    caller: Q
  });
  return /* @__PURE__ */ a(
    Bo,
    {
      scope: o,
      triggerId: H(),
      triggerRef: M,
      contentId: H(),
      open: p,
      onOpenChange: i,
      onOpenToggle: c.useCallback(() => i((f) => !f), [i]),
      modal: d,
      children: /* @__PURE__ */ a(yo, { ...m, open: p, onOpenChange: i, dir: t, modal: d, children: n })
    }
  );
};
en.displayName = Q;
var nn = "DropdownMenuTrigger", on = c.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, disabled: t = !1, ...r } = e, s = Qe(nn, n), u = w(n);
    return /* @__PURE__ */ a(So, { asChild: !0, ...u, children: /* @__PURE__ */ a(
      A.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": t ? "" : void 0,
        disabled: t,
        ...r,
        ref: Re(o, s.triggerRef),
        onPointerDown: v(e.onPointerDown, (d) => {
          !t && d.button === 0 && d.ctrlKey === !1 && (s.onOpenToggle(), s.open || d.preventDefault());
        }),
        onKeyDown: v(e.onKeyDown, (d) => {
          t || (["Enter", " "].includes(d.key) && s.onOpenToggle(), d.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(d.key) && d.preventDefault());
        })
      }
    ) });
  }
);
on.displayName = nn;
var zo = "DropdownMenuPortal", tn = (e) => {
  const { __scopeDropdownMenu: o, ...n } = e, t = w(o);
  return /* @__PURE__ */ a(Io, { ...t, ...n });
};
tn.displayName = zo;
var rn = "DropdownMenuContent", an = c.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = Qe(rn, n), s = w(n), u = c.useRef(!1);
    return /* @__PURE__ */ a(
      xo,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...s,
        ...t,
        ref: o,
        onCloseAutoFocus: v(e.onCloseAutoFocus, (d) => {
          var m;
          u.current || (m = r.triggerRef.current) == null || m.focus(), u.current = !1, d.preventDefault();
        }),
        onInteractOutside: v(e.onInteractOutside, (d) => {
          const m = d.detail.originalEvent, M = m.button === 0 && m.ctrlKey === !0, p = m.button === 2 || M;
          (!r.modal || p) && (u.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
an.displayName = rn;
var Vo = "DropdownMenuGroup", cn = c.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ a(Po, { ...r, ...t, ref: o });
  }
);
cn.displayName = Vo;
var jo = "DropdownMenuLabel", sn = c.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ a(No, { ...r, ...t, ref: o });
  }
);
sn.displayName = jo;
var Xo = "DropdownMenuItem", un = c.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ a(Eo, { ...r, ...t, ref: o });
  }
);
un.displayName = Xo;
var Yo = "DropdownMenuCheckboxItem", dn = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(To, { ...r, ...t, ref: o });
});
dn.displayName = Yo;
var Ho = "DropdownMenuRadioGroup", ln = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(Ao, { ...r, ...t, ref: o });
});
ln.displayName = Ho;
var Wo = "DropdownMenuRadioItem", pn = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(Oo, { ...r, ...t, ref: o });
});
pn.displayName = Wo;
var Zo = "DropdownMenuItemIndicator", fn = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(ko, { ...r, ...t, ref: o });
});
fn.displayName = Zo;
var qo = "DropdownMenuSeparator", mn = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(Lo, { ...r, ...t, ref: o });
});
mn.displayName = qo;
var Jo = "DropdownMenuArrow", Qo = c.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ a(Go, { ...r, ...t, ref: o });
  }
);
Qo.displayName = Jo;
var et = (e) => {
  const { __scopeDropdownMenu: o, children: n, open: t, onOpenChange: r, defaultOpen: s } = e, u = w(o), [d, m] = De({
    prop: t,
    defaultProp: s ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ a(Fo, { ...u, open: d, onOpenChange: m, children: n });
}, nt = "DropdownMenuSubTrigger", Mn = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(Ko, { ...r, ...t, ref: o });
});
Mn.displayName = nt;
var ot = "DropdownMenuSubContent", vn = c.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ a(
    $o,
    {
      ...r,
      ...t,
      ref: o,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
vn.displayName = ot;
var tt = en, rt = on, gn = tn, hn = an, at = cn, wn = sn, Cn = un, _n = dn, ct = ln, Rn = pn, bn = fn, Dn = mn, st = et, yn = Mn, Sn = vn;
const Gt = tt, Ft = rt, Kt = at, $t = gn, Ut = st, Bt = ct, it = S(({ className: e, inset: o, children: n, ...t }, r) => /* @__PURE__ */ ae(
  yn,
  {
    ref: r,
    className: D(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      o && "pl-8",
      e
    ),
    ...t,
    children: [
      n,
      /* @__PURE__ */ a(Hn, { className: "ml-auto size-4" })
    ]
  }
));
it.displayName = yn.displayName;
const ut = S(({ className: e, ...o }, n) => /* @__PURE__ */ a(
  Sn,
  {
    ref: n,
    className: D(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...o
  }
));
ut.displayName = Sn.displayName;
const dt = S(({ className: e, sideOffset: o = 4, ...n }, t) => /* @__PURE__ */ a(gn, { children: /* @__PURE__ */ a(
  hn,
  {
    ref: t,
    sideOffset: o,
    className: D(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
dt.displayName = hn.displayName;
const lt = S(({ className: e, inset: o, ...n }, t) => /* @__PURE__ */ a(
  Cn,
  {
    ref: t,
    className: D(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      o && "pl-8",
      e
    ),
    ...n
  }
));
lt.displayName = Cn.displayName;
const pt = S(({ className: e, children: o, checked: n, ...t }, r) => /* @__PURE__ */ ae(
  _n,
  {
    ref: r,
    className: D(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...t,
    children: [
      /* @__PURE__ */ a("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(bn, { children: /* @__PURE__ */ a(Wn, { className: "size-4" }) }) }),
      o
    ]
  }
));
pt.displayName = _n.displayName;
const ft = S(({ className: e, children: o, ...n }, t) => /* @__PURE__ */ ae(
  Rn,
  {
    ref: t,
    className: D(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ a("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(bn, { children: /* @__PURE__ */ a(Zn, { className: "size-4 fill-current" }) }) }),
      o
    ]
  }
));
ft.displayName = Rn.displayName;
const mt = S(({ className: e, inset: o, ...n }, t) => /* @__PURE__ */ a(
  wn,
  {
    ref: t,
    className: D("px-2 py-1.5 text-sm font-semibold", o && "pl-8", e),
    ...n
  }
));
mt.displayName = wn.displayName;
const Mt = S(({ className: e, ...o }, n) => /* @__PURE__ */ a(
  Dn,
  {
    ref: n,
    className: D("-mx-1 my-1 h-px bg-muted", e),
    ...o
  }
));
Mt.displayName = Dn.displayName;
const vt = ({ className: e, ...o }) => /* @__PURE__ */ a("span", { className: D("ml-auto text-xs tracking-widest opacity-60", e), ...o });
vt.displayName = "DropdownMenuShortcut";
export {
  Gt as DropdownMenu,
  pt as DropdownMenuCheckboxItem,
  dt as DropdownMenuContent,
  Kt as DropdownMenuGroup,
  lt as DropdownMenuItem,
  mt as DropdownMenuLabel,
  $t as DropdownMenuPortal,
  Bt as DropdownMenuRadioGroup,
  ft as DropdownMenuRadioItem,
  Mt as DropdownMenuSeparator,
  vt as DropdownMenuShortcut,
  Ut as DropdownMenuSub,
  ut as DropdownMenuSubContent,
  it as DropdownMenuSubTrigger,
  Ft as DropdownMenuTrigger
};
//# sourceMappingURL=dropdown-menu.js.map
